import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import Link from '../../../components/Link';
import { Sprawy } from '../../sprawy/Sprawy';
import s from '../../content.scss';
import { wybierzGmine } from '../../../actions/gminy';
import PaperTile from '../../../components/PaperTile/PaperTile';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { notFoundImageURL } from '../../../config';
import Stepper, { Step } from '../../../components/Stepper';
import fetch from '../../../core/fetch';
import godloPolski from './godlo-Polski.png';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';

import powrot_do_mapy from './powrot_do_mapy.png';
import cmentarzLogo from './logo_cmentarz.png';
import ihubLogo from './logo_inspire.png';


class SzczegolyUrzedu extends React.Component {
  state = {
    showKonto: false,
    showInfo: false,
    filter_text: '',
    colors: 'normal',
    style: layoutColorStyle,
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = layoutColorStyle;
    if (colors !== 'normal') {
      style = headerStyle;
    }
    this.setState({ colors, style });
  }

  serviceFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = e.target.value.replace(/\s\s+/g, ' ');
    this.setState({ filter_text: value });
  };

  render() {
    let customerId = 'E819A999-4CAF-45D1-AF89-A38628EBFF6F'; // testowy eboi
    let filteredServicesCount = 0;
    return (
      <div>
        <Stepper>
          <Step title="Urzędy" url={'/urzad/'} />
          <Step title={this.props.districts ? this.props.districts[this.props.prefix].place : null} />
        </Stepper>
        {
          this.props.districts && Object.keys(this.props.districts).filter(
            urzad => urzad === this.props.prefix
          ).map(
            (urzad, index) => <div key={index}>
              <PaperHeader title={this.props.districts[urzad].name} text="" />
              <div className="paper-area" style={{ color: this.state.style[this.state.colors].color, backgroundColor: this.state.style[this.state.colors].backgroundColor }}>
                <Grid className="poszerz">
                  <Row>
                    <Col className="centruj" sm={2} xs={6}>
                      <img className="herby" role="presentation" src={godloPolski} />
                    </Col>
                    <Col className="centruj" smHidden mdHidden lgHidden xs={6}>
                      <img className="herby" role="presentation" src={this.props.districts[urzad].herb ?
                        `${process.env.OLD_IHUB}/upload/herby/${this.props.districts[urzad].herb}`
                      : notFoundImageURL
                    } />
                    
                    </Col>
                    <Col xs={12} smHidden mdHidden lgHidden className="info-button">
                      <div role="button" onClick={() => this.setState({ showInfo: !this.state.showInfo })}>
                        <span>{!this.state.showInfo ? 'Rozwiń' : 'Zwiń'}</span>
                        <span className={`fa fa-chevron-${!this.state.showInfo ? 'down' : 'up'}`} aria-hidden="true" />
                      </div>
                    </Col>
                    <Col className="centruj" xs={12} sm={8}>
                      <div className={`paper-content-area ${!this.state.showInfo ? 'ukryj-info' : null}`}>
                        <Row className="eus-specs"><Col xs={4}>Miejsce załatwiania:</Col><Col xs={8}>{this.props.districts[urzad].placeOfSettling}</Col></Row>
                        <Row className="eus-specs"><Col xs={4}>Miejscowość:</Col><Col xs={8}>{this.props.districts[urzad].place}</Col></Row>
                        <Row className="eus-specs"><Col xs={4}>Adres:</Col><Col xs={8}>{this.props.districts[urzad].street.length !== 0 ? `${this.props.districts[urzad].street}` : this.props.districts[urzad].place}&nbsp;{this.props.districts[urzad].nrBuilding}{this.props.districts[urzad].nrLocal.length !== 0 ? `/${this.props.districts[urzad].nrLocal}` : null}</Col></Row>
                        <Row className="eus-specs"><Col xs={4}></Col><Col xs={8}>{this.props.districts[urzad].zipCode}</Col></Row>
                        <Row className="eus-specs"><Col xs={4}>Telefon:</Col><Col xs={8}>{this.props.districts[urzad].phone}</Col></Row>
                        <Row className="eus-specs"><Col xs={4}>Faks:</Col><Col xs={8}>{this.props.districts[urzad].fax}</Col></Row>
                        <Row className="eus-specs"><Col xs={4}>Strona:</Col><Col xs={8}><a href={this.props.districts[urzad].pageWWW} target="_blank" rel="noopener noreferrer">{this.props.districts[urzad].pageWWW}</a></Col></Row>
                        <Row className="eus-specs"><Col xs={4}>Strona BIP:</Col><Col xs={8}><a href={this.props.districts[urzad].pageBIP} target="_blank" rel="noopener noreferrer">{this.props.districts[urzad].pageBIP}</a></Col></Row>
                        <Row className="eus-specs"><Col xs={4}>Adres e-mail:</Col><Col xs={8}><a href={`mailto:${this.props.districts[urzad].email}?subject=Dotyczy e-usług`}>{this.props.districts[urzad].email}</a></Col></Row>
                        <Row className="eus-specs"><Col xs={4}>Godziny pracy urzędu:</Col><Col xs={8}>{this.props.districts[urzad].workingHours.map(
                          (item, i) => <div key={i}>{item}</div>,
                        )}</Col></Row>
                        {/* {this.props.districts[urzad].przyjecia.godzPrzyjec.length !== 0 ? <Row className="eus-specs"><Col xs={4}>Godziny przyjęć interesantów przez burmistrza:</Col><Col xs={8}>{this.props.districts[urzad].przyjecia.godzPrzyjec.map(
                          (item, i) => <div key={i}>{item}</div>,
                        )}</Col></Row>
                        : null} */}
                        {/* {this.props.districts[urzad].przyjecia.kasa.length !== 0 ? <Row className="eus-specs"><Col xs={4}>Kasa urzędu czynna:</Col><Col xs={8}>{this.props.districts[urzad].przyjecia.kasa.map(
                          (item, i) => <div key={i}>{item}</div>,
                        )}</Col></Row>
                        : null} */}
                        <Row className="eus-specs">
                          <Col xs={4}>Konto:</Col>
                          {this.props.districts[urzad].bankAccounts.length === 1 ?
                            <Col xs={8}>{this.props.districts[urzad].bankAccounts.map(
                              (item, i) => <div className="eus-item" key={i}>{item}</div>,
                            )}</Col>
                            :
                            <Col className={`${!this.state.showKonto ? 'ukryj' : null}`} xs={8}>
                              <div onClick={() => this.setState({ showKonto: !this.state.showKonto })} className="wiecej-button">
                                <span>{!this.state.showKonto ? 'Rozwiń' : 'Zwiń'}</span>
                                <span className={`fa fa-chevron-${!this.state.showKonto ? 'down' : 'up'}`} aria-hidden="true" />
                              </div>
                              <content>
                                {this.props.districts[urzad].bankAccounts.map(
                                  (item, i) =>
                                    <div className="eus-item" key={i}>{item}</div>,
                                )}
                              </content>
                            </Col>
                          }
                        </Row>
                        <Row className="eus-specs"><Col xs={12}><a id="deklaracja" href={`/urzad/${this.props.districts[urzad].prefix}/deklaracja-dostepnosci`}>Deklaracja dostępności</a></Col></Row>
                      </div>
                    </Col>
                    <Col xsHidden sm={2}>
                      <img
                        className="herby" role="presentation"
                        width="100"
                        src={Object.keys(this.props.districts).indexOf(this.props.districts[urzad].prefix) >= 0 && this.props.districts[urzad].prefix ?
                          `${process.env.OLD_IHUB}/upload/herby/${this.props.districts[urzad].herb}`
                        : notFoundImageURL}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Row className="eus-specs">
                      <Col xs={4} />
                      <Col xs={3}>
                        <h3>Portal mapowy</h3>
                      </Col>
                      {this.props.districts[urzad].prefix === 'gmina_siekierczyn' ?
                        <Col xs={5}>
                          <h3>Portal cmentarzy</h3>
                        </Col> : null
                      }
                    </Row>
                    <Row className="eus-specs">
                      <Col xs={4} />
                      { this.props.districts[urzad].prefix === 'krosno' ?
                        <Col xs={3}>
                          <a id="portal-link" href={`https://e-spdp.pl/${this.props.districts[urzad].prefix}`}>
                            <img width={130} height={30} src={ihubLogo} role="presentation" />
                          </a>
                        </Col> :
                        <Col xs={3}>
                          <a id="portal-link" href={`http://mapa.inspire-hub.pl/#/${this.props.districts[urzad].prefix}`}>
                            <img width={130} height={30} src={ihubLogo} role="presentation" />
                          </a>
                        </Col>}
                      {this.props.districts[urzad].prefix === 'gmina_siekierczyn' ?
                        <Col xs={5}>
                          <a id="cmentarze-link" href={`https://e-spdp.pl/${this.props.districts[urzad].prefix}`}>
                            <img width={180} height={50} src={cmentarzLogo} role="presentation" />
                          </a>
                        </Col>
                      : null}

                      {this.props.districts[urzad].prefix === 'gmina_gorzyca' || this.props.districts[urzad].prefix === 'gmina_slubice_powiat_slubicki' ?
                        <Row className="eus-specs">
                          <Col xs={4} />
                          <Col xs={5}>
                            <a id="portal-link" href={`https://e-spdp.pl/urzad/${this.props.districts[urzad].prefix}/cmentarze`}>
                              CMENTARZE
                            </a>
                          </Col>
                        </Row>
                      : null}
                    </Row>
                  </Row>
                </Grid>
              </div>
              <PaperHeader title="E-usługi" text="" />
              <Row>
                <input type="text"
                  className="form-control"
                  style={{ width: '60%', left: '20%', position: 'relative', margin: '25px 0px 15px 0px' }}
                  value={this.state.filter_text}
                  placeholder="Wyszukaj usługę..."
                  onChange={(e) => this.serviceFilterChange(e)}
                />
              {this.props.districts[urzad].services.map(
                (item, i) => {
                  const baseURL = (urzad === 'gmina_aleksandrow_lodzki') ? '/services' : '/eservices';
                  let baseQString = `${baseURL}?district=${this.props.districts[urzad].teryt}&serviceType=${item}`;
                  if (this.props.user) {
                    baseQString += `&customerId=${this.props.user.ID}`;
                  }
                  if (this.props.eservices[item].title.toLowerCase().includes(this.state.filter_text.toLowerCase())) {
                    filteredServicesCount += 1;
                    return <Col key={i} xs={12} sm={6} md={4}><PaperTile href={`${baseQString}`} text={this.props.eservices[item].title} epuap={this.props.eservices[item].requiresEPUAP} disabled={this.props.eservices[item].disabled}/></Col>;
                  }
                },
              )}
                {filteredServicesCount === 0 ?
                  <p style={{ width: '60%', left: '20%', position: 'relative' }}>
                    <center>Brak wyników wyszukiwania</center></p>
                : null}
              </Row>
            </div>,
          )
        }
      </div>
    );
  }
}
// export default withStyles(s)(SzczegolyUrzedu);

const mapState = (state) => ({
  wybranaGmina: state.gminy.wybranaGmina,
  districts: state.district.districts,
  eservices: state.district.eservices
});

const mapDispatch = {
  wybierzGmine,
};

export default withStyles(s)(connect(mapState, mapDispatch)(SzczegolyUrzedu));


// WEBPACK FOOTER //
// src/routes/urzad/szczegolyUrzedu/SzczegolyUrzedu.js